import { actionCreator } from '@blink/components/src/utils';

import {
    GET_ASSETS_TO_VAULTS,
    GET_MARGIN_ACCOUNTS,
    GET_USER_VAULTS,
    SET_USER_VAULTS,
    SET_USER_MARGIN_ACCOUNTS,
} from './constants';
import { UserVault } from './index';

import { MarginAccount } from '@/shared/api/vault';

export const getUserVaults = () => actionCreator(GET_USER_VAULTS);

export const setUserVaults = (payload: UserVault[]) => actionCreator(SET_USER_VAULTS, payload);

export const getAssetsToVaultsAction = () => actionCreator(GET_ASSETS_TO_VAULTS);

export const getUserMarginAccounts = (payload: { address: string; withoutCache?: boolean }) =>
    actionCreator(GET_MARGIN_ACCOUNTS, payload);

export const setUserMarginAccounts = (payload: MarginAccount[]) =>
    actionCreator(SET_USER_MARGIN_ACCOUNTS, payload);
